import angular from 'angular';
import { some } from 'lodash';

module.exports = angular.module('common.filters.some', [])
.filter('some', () => some)
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/some.js
 **/